/**
 * lucide-react v0.219.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const TrendingUp = createLucideIcon("TrendingUp", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);

export { TrendingUp as default };
//# sourceMappingURL=trending-up.js.map
